import { Diagnostic, SettingsStorageBase } from '@lmnop/web-core';

export class WebsiteSettingsStorage extends SettingsStorageBase {
    protected async getSettingsFromStorage(): Promise<any> {
        Diagnostic.debug('WebsiteSettingsStorage - getSettingsFromStorage - local.get started');

        let res = JSON.parse(localStorage.getItem('settings') ?? 'null', this.jsonPropertyReviver);

        return Promise.resolve(res);
    }

    protected async setSettingsToStorage(settings: any): Promise<void> {
        Diagnostic.debug('WebsiteSettingsStorage - setSettingsToStorage - local.set started');

        localStorage.setItem('settings', this.getSettingsJSON(settings));

        Diagnostic.debug('WebsiteSettingsStorage - setSettingsToStorage - local.set ended');
        return Promise.resolve();
    }

    protected async backupSettingsToStorage(settings: any, backupSettingName: string): Promise<void> {
        let backupSettings: string = JSON.stringify(settings, this.jsonPropertyReplace);

        localStorage.setItem(backupSettingName, backupSettings);
    }
}
